module.exports = __webpack_public_path__ + "static/media/pulverizador.a874b10a.svg";